export type NormalizedTier = 'resident' | 'associate';

export type RawTier = string | null | undefined;

/**
 * The DB tier enum is `resident | associate`, but legacy quiz answers
 * and some therapist-facing copy still use `intern` interchangeably
 * with `resident`. Normalize at every boundary.
 */
export function normalizeTier(raw: RawTier): NormalizedTier {
  const t = raw?.toLowerCase() ?? '';
  if (t === 'associate') return 'associate';
  return 'resident';
}
